'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Fireball = function (_Phaser$Sprite) {
  _inherits(Fireball, _Phaser$Sprite);

  function Fireball(game, x, y, height, velocity) {
    _classCallCheck(this, Fireball);

    var _this = _possibleConstructorReturn(this, (Fireball.__proto__ || Object.getPrototypeOf(Fireball)).call(this, game, x, y, 'fireball'));

    _this.anchor.set(0.5);
    _this.maxHeight = y;
    _this.minHeight = y - height;
    _this.startVelocity = velocity;
    _this.game.physics.enable(_this);
    _this.body.allowGravity = false;
    _this.body.immovable = true;
    _this.body.collideWorldBounds = true;
    _this.body.velocity.y = velocity;
    // animations
    _this.animations.add('fire', [0]);
    _this.animations.play('fire');
    return _this;
  }

  _createClass(Fireball, [{
    key: 'update',
    value: function update() {
      if (this.y < this.minHeight) {
        this.body.velocity.y = Math.abs(this.startVelocity);
        this.scale.y = -1;
      } else if (this.y > this.maxHeight) {
        this.body.velocity.y = -this.startVelocity;
        this.scale.y = 1;
      }
    }
  }]);

  return Fireball;
}(_phaser2.default.Sprite);

exports.default = Fireball;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Fireball.js
// module id = 343
// module chunks = 0